import { notFound } from "next/navigation";
import { z } from "zod";
import { env } from "~/env.mjs";
import domainsData from "../../domains.json";

const configSchema = z.object({
	defaultLocale: z.string(),
	locales: z.array(z.string()),
	domains: z.array(
		z.object({
			domain: z.string(),
			api: z.record(z.string()),
			defaultLocale: z.string(),
			locales: z.array(z.string()),
			alwaysPrefix: z.boolean().default(false),
			indexNowKey: z.string().nullable(),
		}),
	),
});

export type Config = z.infer<typeof configSchema>;

export const config = configSchema.parse({
	defaultLocale: env.NEXT_PUBLIC_LOCALE,
	locales: domainsData.flatMap((domain) => domain.locales),
	domains: domainsData,
});

export function parseLocale(locale: string) {
	const domain = config.domains.find((domain) => domain.locales.includes(locale));

	if (!domain) {
		return notFound();
	}

	return locale;
}
